import classNames from 'classnames';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { TitleDescWithColorProps } from 'eco-design-micro/props/msg/TitleDescProps';
import React, { useState } from 'react';
import './index.scss';

export interface EcoTextTcItemProps extends TitleDescWithColorProps {
    /**
     * 是否是标题
     */
    isHead?: boolean;
    /**
     * 是否打开描述
     */
    isOpen?: boolean;
}
export interface EcoTextTcProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 自定义类名
     */
    className?: string;
    /**
     * 列表值
     */
    items?: EcoTextTcItemProps[];
}

const EcoTextTc: React.FC<EcoTextTcProps> = ({ theme = 'white', items = [], className }) => {
    const prefixCls = `eco-text-tc`;
    const [itemsB, setItemsB] = useState(items || []);
    const compCls = classNames(prefixCls, 'GtmModuleData-section', {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });

    // 点击切换
    const toggleHandle = (item: EcoTextTcItemProps, index: number) => {
        if (!item.desc) {
            return;
        }
        const itemsC = JSON.parse(JSON.stringify(itemsB));
        const toggleItem = itemsC[index];
        toggleItem.isOpen = !toggleItem.isOpen;
        setItemsB([...itemsC]);
    };

    return (
        <div className={compCls} data-section-id="EcoTextTc" data-section-title="Footer TC">
            <div className={`${prefixCls}-content eco-content`}>
                {itemsB.map((item: EcoTextTcItemProps, index: number) => {
                    const hasDesc = !!item.desc;
                    const itemCompCls = classNames({
                        [`${prefixCls}-item`]: true,
                        [`${prefixCls}-item-head`]: item.isHead,
                        [`${prefixCls}-item-open`]: item.isOpen,
                        [`${prefixCls}-item-has-desc`]: hasDesc,
                    });
                    const itemStyleComp = {
                        '--eco-text-tc-titleColor': item.titleColor,
                        '--eco-text-tc-descColor': item.descColor,
                    } as React.CSSProperties;
                    return (
                        <div className={itemCompCls} key={index} style={itemStyleComp}>
                            <div
                                className={`${prefixCls}-title`}
                                onClick={() => {
                                    toggleHandle(item, index);
                                }}
                            >
                                <div className={`${prefixCls}-title-text`} dangerouslySetInnerHTML={{ __html: item.title }}></div>
                                {hasDesc && <EcoIconArrow className={`${prefixCls}-title-icon`} />}
                            </div>
                            <div className={`${prefixCls}-desc`} dangerouslySetInnerHTML={{ __html: item.desc }}></div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EcoTextTc;
